import { render } from "./RealtimePage.vue?vue&type=template&id=03973754&ts=true"
import script from "./RealtimePage.vue?vue&type=script&lang=ts"
export * from "./RealtimePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__